import { LS_KEY } from './consts';
import { debug } from './debug';
/**
 * LocalStorage helpers
 */
export const isStorageSupported = (() => {
    const test = 'localStorageTest';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    }
    catch (e) {
        return false;
    }
})();
export const getLocalStorageValue = (key) => {
    try {
        return isStorageSupported ? window.localStorage.getItem(key) : null;
    }
    catch (_a) {
        debug({ type: 'error', message: 'LocalStorage getItem error' });
        return null;
    }
};
export const setLocalStorageValue = (key, value) => {
    if (isStorageSupported) {
        try {
            window.localStorage.setItem(key, value);
        }
        catch (_a) {
            // no-op
            debug({ type: 'error', message: 'LocalStorage setItem error' });
        }
    }
};
/**
 * Update cache.
 * Expects serialized identitites
 */
export const setCache = (identities) => setLocalStorageValue(LS_KEY, identities);
/**
 * Pull from cache
 */
export const getCache = () => getLocalStorageValue(LS_KEY);
